module.exports = __webpack_public_path__ + "static/media/pythonanywhere.2a5335d5.svg";